import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Row, Col, ListGroup } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

import Docker from './Lessons/Docker.md';
import AWS_CCP from './Lessons/AWS-CCP.md';
import AWS_CDA from './Lessons/AWS-CDA.md';
import Heroku from './Lessons/Heroku.md';
import Netlify from './Lessons/Netlify.md';
import Git from './Lessons/Git.md';
import UseEffectMemoryLeak from './Lessons/UseEffectMemoryLeak.md';

const App = () => {

  const [lesson, setLesson] = useState([]);

  const lessons = [
    { docker: Docker },
    { 'aws-ccp': AWS_CCP },
    { 'aws-cda': AWS_CDA },
    { heroku: Heroku },
    { netlify: Netlify },
    { git: Git },
    { 'useEffect-memory-leak': UseEffectMemoryLeak },

  ]

  var temp = {}
  useEffect(() => {

    //Clear state
    setLesson([]);

    lessons.forEach(element => {
      fetch(Object.values(element))
        .then(response => response.text())
        .then(text => {
          temp[Object.keys(element)] = text
          setLesson(prevLesson => [...prevLesson, temp])
          temp = {}
        })

    })

  }, []);

  return (
    <Router>
      <Row>
        <Col style={{ maxWidth: '250px' }}>
          <ListGroup>
            {
              lesson.map(element => <span key={Object.keys(element)}>
                <Link to={`/${Object.keys(element)}`}>
                  <ListGroup.Item style={{ padding: '2.5px', textAlign: 'center' }}>
                    {Object.keys(element)}
                  </ListGroup.Item>
                </Link>
              </span>)
            }
            <ListGroup.Item style={{ padding: '2.5px', textAlign: 'center' }}>
              <a href='https://github.com/dulaya/notes' target="_blank" rel="noopener noreferrer">Repo (private)</a>
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col>
          {
            lesson.map(element => <span key={Object.keys(element)}>
              <Route exact path={`/${Object.keys(element)}`}>
                <ReactMarkdown source={Object.values(element).toString()} />
              </Route>
            </span>)
          }
        </Col>
      </Row>

    </Router>
  );
}

export default App;
